import { getAdminTotalUnreadCount, getConsoleOpenChatUnreadCount } from '@/api';
import { UNREAD_UPDATE_COUNTS } from './action-typs';

const parseUnreadCount = res => {
  const data = res?.data?.body?.data || res?.data?.body || {};
  const value = Number(data.unread_count);
  return Number.isFinite(value) ? value : 0;
};

export const setUnreadCounts = ({ inquiry = 0, openChat = 0 } = {}) => ({
  type: UNREAD_UPDATE_COUNTS,
  payload: { inquiry, openChat }
});

export const refreshUnreadCounts = () => async dispatch => {
  let inquiry = 0;
  let openChat = 0;

  try {
    const res = await getAdminTotalUnreadCount();
    inquiry = parseUnreadCount(res);
  } catch (e) {
    inquiry = 0;
  }

  try {
    const res = await getConsoleOpenChatUnreadCount();
    openChat = parseUnreadCount(res);
  } catch (e) {
    openChat = 0;
  }

  dispatch(setUnreadCounts({ inquiry, openChat }));
};
